import { render } from "./MemberDealsRedeem.vue?vue&type=template&id=7ff117e9&scoped=true"
import script from "./MemberDealsRedeem.vue?vue&type=script&lang=js"
export * from "./MemberDealsRedeem.vue?vue&type=script&lang=js"

import "./MemberDealsRedeem.vue?vue&type=style&index=0&id=7ff117e9&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff117e9"]])

export default __exports__